<template>
  <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M42 10.5V21" stroke="#FFED48" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M64.274 19.7266L56.8494 27.1512" stroke="#FFED48" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M73.5 42H63" stroke="#FFED48" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M64.274 64.2742L56.8494 56.8496" stroke="#FFED48" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M42 73.5V63" stroke="#FFED48" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19.7262 64.2742L27.1508 56.8496" stroke="#FFED48" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.5 42H21" stroke="#FFED48" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19.7262 19.7266L27.1508 27.1512" stroke="#FFED48" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
